/* section handler */

window.theme = window.theme || {};
window.home_video_list = window.home_video_list || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.originalEvent.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
theme.Sliders = (function() {
   
  function Sliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.sliderId = $("#shopify-section-"+sectionId) ;
   	this.sliderNamspace = "#home-slider-"+sectionId;
   
    this.countdownHolder = $(".count_holder_small-"+sectionId);
    this.sliderWrapper = $("#slideshow_wrapper-"+sectionId);
    this.slider = $("#home-slider-"+sectionId);
    this.sliderTxt =  "#home-slider-"+sectionId;
    
    this.sliderCamera = $("#home-camera-slider-"+sectionId);
    this.sliderOverlay = $("#home-slider-overlay-"+sectionId);
    
    this.countdownHolder = $(".count_holder_small-"+sectionId);
    
    this.options = {
      show_slideshow: $("#slideshow_wrapper-"+sectionId).data('show_slideshow'),
      slideshow_auto: $("#slideshow_wrapper-"+sectionId).data('slideshow_auto'),
      show_slideshow_dots: $("#slideshow_wrapper-"+sectionId).data('show_slideshow_dots'),
      slideshow_interval: $("#slideshow_wrapper-"+sectionId).data('slideshow_interval'),
      slider_align_top: $("#slideshow_wrapper-"+sectionId).data('slider_align_top')
    };
    this._handleSlideshow();
    this._initSizeStiker();
  }

  Sliders.prototype = _.assignIn({}, Sliders.prototype, {
    _handleSlideshow: function() {
        if(this.options.slider_align_top == "1") {
          $('.templateIndex').addClass('slider-align-top');
        }else{
          $('.templateIndex').removeClass('slider-align-top');
        }
        sliderOverlay = this.sliderOverlay;
        if (this.slider.length) switch (this.options.show_slideshow) {
            case "camera":
                this.sliderCamera.camera({
                    loader: "none",
                    imagePath: window.blank_gif,
                    autoAdvance: this.options.slideshow_auto,
                    mobileAutoAdvance: this.options.slideshow_auto,
                    pagination: this.options.show_slideshow_dots,
                    thumbnails: !1,
                    playPause: !1
                }), imagesLoaded(this.sliderTxt, function() {
                    sliderOverlay.hide()
                });
                break;
            case "responsive":
                this.slider.responsiveSlider({
                    autoplay: this.options.slideshow_auto,
                    interval: this.options.slideshow_interval,
                    transitionTime: 300
                }), imagesLoaded(this.sliderTxt, function() {
                    sliderOverlay.hide()
                });
                break;
            case "flexslider":
                this.slider.flexslider({
                    animation: "fade",
                    prevText: "",
                    nextText: "",
                    slideshowSpeed: this.options.slideshow_interval,
                    slideshow: this.options.slideshow_auto,
                    controlNav: this.options.show_slideshow_dots,
                    start: function(e) {
                        $("body").removeClass("loading")
                    }
                }), imagesLoaded(this.sliderTxt, function() {
                    sliderOverlay.hide()
                })
        }
      this._countdown();
      if (this.slider.length){
      	this._mockupCaptionSlider();
        this._resizeFontSize();
      }
    },
    _countdown: function() {
      var currentDay = new Date();
      !$('html').hasClass('ie8') &&( this.countdownHolder.length && (
        this.countdownHolder.each(function(){
          var offerDay = $(this).data('slide_expires').split('-');
          var offerDay = new Date( offerDay[2], (parseInt(offerDay[0]) - 1), offerDay[1] );
          if(currentDay < offerDay){
            $(this).children().countdown({until: offerDay});
          }else{
            $(this).hide();
          }
        })
      ))
    },
    _resizeFontSize: function() {
      var slider = this.slider;
      var sliderTxt =  this.sliderTxt; 
      $(window).resize(function() {
        if(slider.length && $(sliderTxt + ' .home-slide-item').length) { 
          $(sliderTxt + ' .home-slide-item').each(function() {
            var slide_id = $(this).data('slide_id');
            var e = $(this).data('general_font_size'),
                a = $(this).data('slide_heading_size'),
                o = $(this).data('slide_caption_size'),
                t = roar.getWidthBrowser(),
                i = a * t / 1200,
                s = o * t / 1200;   
              if (roar.getWidthBrowser() < 1200) {
                  e > i && (i = e), e > s && (s = e), 
                  $(slide_id+" .slide_caption .caption-content").css({
                      "font-size": s
                  }), $(slide_id+" .slide_heading .caption-content").css({
                      "font-size": i
                  })
              } else {
                  $(slide_id+" .slide_caption .caption-content").css({
                      "font-size": o
                  }), $(slide_id+" .slide_heading .caption-content").css({
                      "font-size": a
                  })
              }
          });
        }
      });
    },
   	_mockupCaptionSlider: function() {
      var sliderTxt =  this.sliderTxt; 
      if(this.slider.length && $(sliderTxt + ' .home-slide-item').length) { 
          $(sliderTxt + ' .home-slide-item').each(function() {
            var slide_id = $(this).data('slide_id');
            var e = $(this).data('general_font_size'),
                a = $(this).data('slide_heading_size'),
                o = $(this).data('slide_caption_size'),
                t = roar.getWidthBrowser(),
                i = a * t / 1200,
                s = o * t / 1200;  
              if (roar.getWidthBrowser() < 1200) {
                
           // console.log('heading= '+ i);console.log('caption= '+s);
                  e > i && (i = e), e > s && (s = e), 
                  $(slide_id+" .slide_caption .caption-content").css({
                      "font-size": s
                  }), $(slide_id+" .slide_heading .caption-content").css({
                      "font-size": i
                  })
              } else {
              //  console.log('heading= '+ a);console.log('caption= '+o);
                  $(slide_id+" .slide_caption .caption-content").css({
                      "font-size": o
                  }), $(slide_id+" .slide_heading .caption-content").css({
                      "font-size": a
                  })
              }
          });
        }
    },
    _initSizeStiker:  function() {
      $('.slide-sticky-image').length > 0 && $('.slide-sticky-image').each(function() {
      	var w_width = $( window ).width();
        var current_sticky_width = $(this).data('width');
        if(w_width < 1200) {
        	var n_sticky_width = w_width /1200 * current_sticky_width;
          	$(this).find('.slide-sticky-img').css('width', n_sticky_width);
        }
      });
      $(window).resize(function() {
      $('.slide-sticky-image').length > 0 && $('.slide-sticky-image').each(function() {
      	var w_width = $( window ).width();
        var current_sticky_width = $(this).data('width');
        if(w_width < 1200) {
        	var n_sticky_width = w_width /1200 * current_sticky_width;
          	$(this).find('.slide-sticky-img').css('width', n_sticky_width);
        }
      });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.sliderNamspace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return Sliders;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.YouTubeVideos.loadVideos();
}

theme.YouTubeVideos = (function() {
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
     	modestbranding: 1,
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        branding: 0,
        rel: 0,
        autohide: 1,
      	cc_load_policy: 1,
      	disablekb:0,
      	fs: 1,
      	iv_load_policy: 3,
      	start: 0,
      	end: 0,
        loop: 1,
      	rel:0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.id) {
      return;
    }

    videos[$video.id] = {
      id: $video.id,
      playerId: $video.player_id, 
      videoId: $video.video_id,
      homeVideo: $video.home_video,
      videoSelector: $video.id,
      playerVars: $video.playerDefaults
    };
	
    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }


  function loadVideos() {
    var player;
    var homeVideo;
    var homeVideoWidth;
    var playerWidth;
    var playerHeight;
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        console.log( videos[key]);
        // args.playerVars.controls = args.controls;
        args.playerId.addClass('home_video_bg');
        console.log(args)	;
        // init Player 
        videoPlayers[key] = new YT.Player(key, args);
      }
    }
	sizeBackgroundVideos();
    initEvents();
    youtubeLoaded = true;
  } 
  function onPlayerReady(evt) {
    var videoData = getVideoOptions(evt);
    videoData.playerId.addClass('home_video_bg');
    evt.target.setPlaybackQuality('hd1080');
    evt.target.mute();
    evt.target.setLoop(true);
    sizeBackgroundVideos();
  }
  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended        
      //  console.log('ended');
        videoPlayers[videoData.id].seekTo(videoData.playerVars.start);
        break;
      case 1: // playing
        //setAsPlaying(videoData);
        break;
      case 2: // paused
        //setAsPaused(videoData);
     //   console.log('paused');
        break;
    }
  }
  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }
  function sizeBackgroundVideos() {
  	$('.home_video_bg').each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }
  function sizeBackgroundVideo($player) {
    
    var $slide = $player.closest('.home-video');    
    var player = $player;
    var slideWidth = $slide.width();
    var slideHeight = $slide.height();
    var playerWidth = player.width();
    var playerHeight = player.height();
    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }
	//console.log(playerWidth);
   // console.log(playerHeight);
    $slide.height(playerHeight);
    $player.addClass('home_video_loaded');
  }
  function resizeBackgroundVideos($player) {
  	var $slide = $player.closest('.home-video');    
    var player = $player;
     var w = $(window).width()+200,
      h = $(window).height()+200;

    if (w/h > 16/9){
      player.setSize(w, w/16*9);
      player.css({'left': '0px'});
    } else {
      player.setSize(h/9*16, h);
      player.css({'left': -player.outerWidth()-w/2});
    }   
  }
  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    videoPlayers[key] = new YT.Player(key, args);
   // videoPlayers[key].mute();
   // videoPlayers[key].setLoop(true);
    initEvents();
  }
  function initEvents() {
  	 // Listen to resize to keep a background-size:cover-like layout
      $(window).on('resize.videoPlayer', $.debounce(250, function() {
        if (youtubeLoaded) {
         // console.log('resize');
      //    resizeBackgroundVideos();
        }
      }));
  }
 
  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo
  };
})();

theme.Videos = (function() {
   
  function Videos(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    
    this.videoId = $("#shopify-section-"+sectionId) ;
    this.videoNamspace = "#home-video-"+sectionId;
    this.VideoHomeId = $(this.videoNamspace);
    this.PlayerNamespace = "playerYoutube-"+sectionId ;
    this.PlayerId = $("#playerYoutube-"+sectionId);
    this.VideoHomeCaption = $(this.videoNamspace + " .video_caption");
    this.VideoHomeHeading = $(this.videoNamspace + " .video_heading");
    this.VideoHomeWidth = $(this.videoNamspace + " .video_width");
    this.options = {
      general_font_size: this.VideoHomeId.data('general_font_size'),
      video_heading_size: this.VideoHomeId.data('video_heading_size'),
      video_caption_size: this.VideoHomeId.data('video_caption_size'),
      video_type: this.VideoHomeId.data('video_type')
    };
    this.video_start = this.VideoHomeId.data('video_start');
    var duration = this.VideoHomeId.data('video_duration');
    this.video_end = parseInt(this.video_start ) + parseInt(duration);
    this._mockupCaptionVideo(); 
    
    
    if(this.options.video_type == 'yt-video') {
    	this._handleYoutubeVideo();
    }
  }

  Videos.prototype = _.assignIn({}, Videos.prototype, {
    
    _handleYoutubeVideo: function() {
      var video_params = {
        id: this.PlayerNamespace,
        video_id: this.PlayerId.data('video_id'),
        home_video: this.VideoHomeId,
        player_id: this.PlayerId,
        playerDefaults:{
          modestbranding: 1,
          autoplay: 1,
          controls: 0,
          showinfo: 0,
          branding: 0,
          rel: 0,
          autohide: 1,
          start: this.video_start,
          end: this.video_end
        }
      };
     
      window.home_video_list[video_params.id] = video_params;
      theme.YouTubeVideos.init(video_params);
      theme.YouTubeVideos.loadVideo(video_params.id);
    },
    _mockupCaptionVideo: function() {
  		if (this.VideoHomeId.length) {
            if (roar.getWidthBrowser() < 1200) {
                var e = this.options.general_font_size,
                    a = this.options.video_heading_size,
                    o = this.options.video_caption_size,
                    t = roar.getWidthBrowser(),
                    i = a * t / 1200,
                    s = o * t / 1200;
                e > i && (i = e), e > s && (s = e), this.VideoHomeCaption.css({
                    "font-size": s
                }), this.VideoHomeHeading.css({
                    "font-size": i
                })
            } else {
                var a = this.options.video_heading_size,
                    o = this.options.video_caption_size;
                this.VideoHomeCaption.css({
                    "font-size": o
                }), this.VideoHomeHeading.css({
                    "font-size": a
                })
            }
        }
      this._resizeFontSize();
    },
    _resizeFontSize: function() {
      var VideoHomeId = this.VideoHomeId;
      var VideoHomeHeading =this.VideoHomeHeading;
      var VideoHomeCaption =this.VideoHomeCaption;
       general_font_size = this.options.general_font_size,
       video_heading_size = this.options.video_heading_size,
       video_caption_size = this.options.video_caption_size,
       $(window).resize(function() {
            if (VideoHomeId.length) {
            if (roar.getWidthBrowser() < 1200) {
                var e = general_font_size,
                    a = video_heading_size,
                    o = video_caption_size,
                    t = roar.getWidthBrowser(),
                    i = a * t / 1200,
                    s = o * t / 1200;
                e > i && (i = e), e > s && (s = e), VideoHomeCaption.css({
                    "font-size": s
                }), VideoHomeHeading.css({
                    "font-size": i
                })
            } else {
                var a = video_heading_size,
                    o = video_caption_size;
                VideoHomeCaption.css({
                    "font-size": o
                }), VideoHomeHeading.css({
                    "font-size": a
                })
            }
        }
        });
    },
    onUnload: function(evt) {
	  this.$container.off(this.videoNamspace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return Videos;
})();
theme.homeCollectionsSection = (function() {

  function homeCollectionsSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.homeCollections = $("#home-collections-"+sectionId);
    this.homeCollectionsNamespace = "#home-collections-"+sectionId;
    this.homeCollectionsId =  $("#shopify-section-"+sectionId ) ;
    this.homeSlideCollection = $(".home-collection-content-"+sectionId);
    this.countDown = $('.product_item_countdown_' + sectionId);
    this._init();
  }

  homeCollectionsSection.prototype = _.assignIn({}, homeCollectionsSection.prototype, {
    _init: function() {
      this._initSlide();
      this._initCountdown();
    },
    _initCountdown() {
      if(this.countDown.length > 0) {
        this.countDown.each(function() {
          var year = parseInt( $(this).data("offer_date_year"));
          var month = parseInt( $(this).data("offer_date_month"));
          var day = parseInt( $(this).data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
           $(this).countdown({
              until: offer_date,
              compact: true
            });
          }
          else{
           	$(this).closest('.product_countdown').hide();
          }
        
        });
      }
    },
    _initSlide: function() {
      this.homeSlideCollection.length > 0 && this.homeSlideCollection.each(function(){
        if($(this).data('slide_enabled') == '1') {
        var item_per_page = $(this).data('item_per_page');
       	var pagination = false;
          if($(this).data('show_dots') == '1') {
          	pagination = true;
          }
          var slide_auto= ($(this).data('slide_auto') == 1) ? true : false;
        $(this).owlCarousel({
          navigation: false,
          pagination: pagination,
          mouseDrag: true,
          autoPlay:slide_auto,
          slideSpeed:2000,
          items: item_per_page,
          itemsDesktop: [1199, item_per_page],
          itemsDesktop: [1024, ((Math.floor(parseInt(item_per_page)/1199*1024) > 1)? Math.floor(parseInt(item_per_page)/1199*1024) : 1)],
          itemsDesktopSmall: [991, ((Math.floor(parseInt(item_per_page)/1199*991) > 1)? Math.floor(parseInt(item_per_page)/1199*991) : 1)],
          itemsTablet: [768, ((Math.floor(parseInt(item_per_page)/1199*768) > 1)? Math.floor(parseInt(item_per_page)/1199*768) : 1)],
          itemsMobile: [479, 1],
          scrollPerPage: true
        });
      }
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.homeCollectionsNamespace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });

  return homeCollectionsSection;
})();


theme.specialCollectionSection = (function() {

  function specialCollectionSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.specialCollection = $("#special-collection-"+sectionId);
    this.specialCollectionNamespace = "#special-collection-"+sectionId;
    this.specialCollectionId =  $("#shopify-section-"+sectionId ) ;
    this.specialCollectionSlide = $(".special-collection-slide-"+sectionId);
    this.countDown = $('.product_item_countdown_' + sectionId);
    this.countDownProduct = $('.special-product-countdown-' + sectionId);
    this._init();
  }

  specialCollectionSection.prototype = _.assignIn({}, specialCollectionSection.prototype, {
    _init: function() {
      this._initSlide();
      this._initCountdown();
    },
    _initCountdown() {
      // init count down on collection type
      if(this.countDown.length > 0) {
        this.countDown.each(function() {
          var year = parseInt( $(this).data("offer_date_year"));
          var month = parseInt( $(this).data("offer_date_month"));
          var day = parseInt( $(this).data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
           $(this).countdown({
              until: offer_date,
              compact: true
            });
          }
          else{
           	$(this).closest('.product_countdown').hide();
          }
        
        });
      }
      // init coutdown on product type
       if(this.countDownProduct.length > 0) {
         this.countDownProduct.each(function() {
         	var year = parseInt($(this).data("offer_date_year"));
           var month = parseInt($(this).data("offer_date_month"));
           var day = parseInt($(this).data("offer_date_day"));
           var current_date = new Date();
           var offer_date = new Date(year, day - 1, month);
           if(current_date < offer_date){
             $(this).countdown({
               until: offer_date,
               layout: '<div class="item-time"><span class="dw-time">{dn}</span> <span class="dw-txt">-{dl}-</span></div><div class="item-time"><span class="dw-time">{hn}</span> <span class="dw-txt">-{hl}-</span></div><div class="item-time"><span class="dw-time">{mn}</span> <span class="dw-txt">-{ml}-</span></div><div class="item-time"><span class="dw-time">{sn}</span> <span class="dw-txt">-{sl}-</span></div>'          
             });
           }
           else{
             $(this).hide();
           }
         });
       }
    },
    _initSlide: function() {
      this.specialCollectionSlide.length > 0 && this.specialCollectionSlide.each(function(){
        if($(this).data('slide_enabled') == '1') {
        var item_per_page = $(this).data('item_per_page');
        var slide_auto= ($(this).data('slide_auto') == 1) ? true : false;
       	var pagination = false;
          if($(this).data('show_dots') == '1') {
          	pagination = true;
          }
        $(this).owlCarousel({
          navigation: false,
          pagination: pagination,
          mouseDrag: true,
          autoPlay:slide_auto,
          slideSpeed:2000,
          items: item_per_page,
          itemsDesktop: [1199, item_per_page],
          itemsDesktop: [1024, ((Math.floor(parseInt(item_per_page)/1199*1024) > 1)? Math.floor(parseInt(item_per_page)/1199*1024) : 1)],
          itemsDesktopSmall: [991, ((Math.floor(parseInt(item_per_page)/1199*991) > 1)? Math.floor(parseInt(item_per_page)/1199*991) : 1)],
          itemsTablet: [768, ((Math.floor(parseInt(item_per_page)/1199*768) > 1)? Math.floor(parseInt(item_per_page)/1199*768) : 1)],
          itemsMobile: [479, 1],
          scrollPerPage: true
        });
      }
      });
    },
    onUnload: function(evt) {
      this.$container.off(this.specialCollectionNamespace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });

  return specialCollectionSection;
})();

theme.instafeedSection = (function() {
  function instafeedSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.instafeedId = $("#shopify-section-"+sectionId) ;
    this.instafeedContent = $("#instagram-content-"+sectionId);
    this.instafeedNamspace = "#instagram-content-"+sectionId;
    this.instafeed_list = jQuery("#instagram-list-"+sectionId);
    this.instafeedOptions = {
      limit: this.instafeedContent.data('limit'),
      userId: this.instafeedContent.data('user_id'),
      target: this.instafeedContent.data('target'),
      instagram_token: this.instafeedContent.data('instagram_token')
    }
    this._init();
  }

  instafeedSection.prototype = _.assignIn({}, instafeedSection.prototype, {
    _init: function() {
      var instafeed_list = this.instafeed_list;
      var limit = this.instafeedOptions.limit;
      var target = this.instafeedOptions.target;
      var instagram_token = this.instafeedOptions.instagram_token;
      var userId = this.instafeedOptions.userId;
      var auto_slide = (this.instafeedContent.data('auto_slide') == '1') ? true : false;
        var feed = new Instafeed({
          get: "user",
          target: target,
          accessToken: instagram_token,
          userId: userId,
          limit: limit,
          resolution: "low_resolution",
          resolution2: "standard_resolution",
          after: function() {
            instafeed_list.owlCarousel({
              navigation: false,
              pagination: false,
              mouseDrag: true,
              autoPlay:auto_slide,
              slideSpeed:2000,
              items: 6,
              itemsDesktop : [1199,6],
              itemsDesktopSmall : [991,6],
              itemsTablet: [768,6],
              itemsMobile : [479,6],
              scrollPerPage: false
            });
          }
        });
        feed.run();
    },
    onUnload: function(evt) {
	  this.$container.off(this.instafeedNamspace);
    }
  });
  return instafeedSection;
})();

theme.photoBoardSection = (function() {
  function photoBoardSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.photoBoardId = $("#shopify-section-"+sectionId) ;
    this.photoBoard = $("#photos_board-"+sectionId);
    this.photoBoardNamspace = "#photo-board-wrapper-"+sectionId;
    this._init();
  }

  photoBoardSection.prototype = _.assignIn({}, photoBoardSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.photoBoardNamspace);
    }
  });
  return photoBoardSection;
})();
function hexToRgbA(hex, opacity){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
    }
    throw new Error('Bad Hex');
}
theme.whiteSpaceSection = (function() {
  function whiteSpaceSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.whiteSpaceId = $("#shopify-section-"+sectionId) ;
    this.whiteSpace = $("#white-space-"+sectionId);
    this.whiteSpaceNamspace = "#white-space-"+sectionId;
    this._init();
  }

  whiteSpaceSection.prototype = _.assignIn({}, whiteSpaceSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.whiteSpaceNamspace);
    }
  });
  return whiteSpaceSection;
})();

theme.specialLineSection = (function() {
  function specialLineSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.specialLineId = $("#shopify-section-"+sectionId) ;
    this.specialLine = $("#special-line-"+sectionId);
    this.specialLineNamspace = "#special-line-"+sectionId;
    this._init();
  }

  specialLineSection.prototype = _.assignIn({}, specialLineSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.specialLineNamspace);
    }
  });
  return specialLineSection;
})();
theme.homeProductSection = (function() {
  function homeProductSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.homeProductId = $("#shopify-section-"+sectionId) ;
    this.homeProduct = $("#home-product-"+sectionId);
    this.homeProductNamspace = "#home-product-"+sectionId;
    this.countDown = $("#countdown_"+sectionId);
    this._init();
  }

  homeProductSection.prototype = _.assignIn({}, homeProductSection.prototype, {
    _init: function() {
      this._initCountdown();
    },
    _initCountdown() {
      if(this.countDown.length > 0) {
         var year = parseInt(this.countDown.data("offer_date_year"));
          var month = parseInt(this.countDown.data("offer_date_month"));
          var day = parseInt(this.countDown.data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
            this.countDown.countdown({
              until: offer_date,
              layout: '<div class="item-time"><span class="dw-time">{dn}</span> <span class="dw-txt">-{dl}-</span></div><div class="item-time"><span class="dw-time">{hn}</span> <span class="dw-txt">-{hl}-</span></div><div class="item-time"><span class="dw-time">{mn}</span> <span class="dw-txt">-{ml}-</span></div><div class="item-time"><span class="dw-time">{sn}</span> <span class="dw-txt">-{sl}-</span></div>'          
            });
          }
          else{
            this.countDown.hide();
          }
      }
    },
    onUnload: function(evt) {
	  this.$container.off(this.homeProductNamspace);
    }
  });
  return homeProductSection;
})();
theme.textBannerSection = (function() {
  function textBannerSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.textBannerId = $("#shopify-section-"+sectionId) ;
    this.textBanner = $("#text-banner-"+sectionId);
    this.textBannerNamspace = "#text-banner-"+sectionId;
    this._init();
  }

  textBannerSection.prototype = _.assignIn({}, textBannerSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.textBannerNamspace);
    }
  });
  return textBannerSection;
})();

theme.promotionSection = (function() {
  function promotionSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.promotionId = $("#shopify-section-"+sectionId) ;
    this.promotion = $("#promotion-"+sectionId);
    this.promotionNamspace = "#promotion-"+sectionId;
    this._init();
  }

  promotionSection.prototype = _.assignIn({}, promotionSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.promotionNamspace);
    }
  });
  return promotionSection;
})();
theme.bannerSection = (function() {
  function bannerSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.bannerId = $("#shopify-section-"+sectionId) ;
    this.banner = $("#banner-"+sectionId);
    this.bannerNamspace = "#banner-"+sectionId;
    this._init();
  }

  bannerSection.prototype = _.assignIn({}, bannerSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.bannerNamspace);
    }
  });
  return bannerSection;
})();
theme.deliverySection = (function() {
  function deliverySection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.deliveryId = $("#shopify-section-"+sectionId) ;
    this.delivery = $("#delivery-process-"+sectionId);
    this.deliveryNamspace = "#delivery-process-"+sectionId;
    this._init();
  }

  deliverySection.prototype = _.assignIn({}, deliverySection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.deliveryNamspace);
    }
  });
  return deliverySection;
})();
theme.Testimonials = (function() {
  function Testimonials(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.testimonial = $("#testimonials-slide-"+sectionId);
    this.testimonialNamspace = "#testimonials-"+sectionId;
    this.testimonialId = $("#shopify-section-"+sectionId) ;
    if($("#testimonials-"+sectionId).data("auto_slide") == '1' ){
      var auto_slide  = true;
    }else{
      var auto_slide  = false;
    }
    var options = this.options = {
      autoPlay:auto_slide,
      slideSpeed:2000,
      navigation: !0,
      pagination: !1,
      mouseDrag: !1,
      lazyLoad: !0,
      scrollPerPage: !0,
      items: 1,
      itemsDesktop: [1199, 1],
      itemsDesktopSmall: [991, 1],
      itemsTablet: [768, 1],
      itemsTabletSmall: [767, 1],
      itemsMobile: [479, 1],
      navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>']
    };
    this._init();
  }

  Testimonials.prototype = _.assignIn({}, Testimonials.prototype, {
    _init: function() {
    	this.testimonial.length && this.testimonial.owlCarousel(this.options);
    },
    onUnload: function(evt) {
	  this.$container.off(this.testimonialNamspace);
    },
    onSelect: function(evt) {
    },
    onBlockSelect: function(evt) {
    },
    onBlockDeselect: function(evt) {
    },
  });
  return Testimonials;
})();

theme.homeBlog = (function() {
  function homeBlog(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
    this.homeBlogId = $("#shopify-section-"+sectionId) ;
    this.homeBlog = $("#home-blog-"+sectionId);
    this.articleContent = $("#article-list-"+sectionId);
    this.homeBlogNamspace = "#home-blog-"+sectionId;
    this.blog_slide =  this.homeBlog.data("blog_slide");
    var blog_item_slide = this.blog_item_slide = this.homeBlog.data("blog_item_slide");
    if( this.homeBlog.data("blog_slide_dot") == "1" ) {
      var blog_pagination = true;
    }else{
      var blog_pagination = false;
    }
    if( this.homeBlog.data("blog_slide_auto") == "1" ) {
      var blog_slide_auto = true;
    }else{
      var blog_slide_auto = false;
    }
    var options = this.options = {
      autoPlay:blog_slide_auto,
      slideSpeed:2000,
      mouseDrag: true,
      items: blog_item_slide,
      itemsDesktop: [1199, blog_item_slide],
      itemsDesktopSmall: [991, blog_item_slide],
      itemsTablet: [768, 2],
      itemsTabletSmall: [767, 2],
      itemsMobile: [479, 1],
      pagination: blog_pagination
    };
    this._init();
  }

  homeBlog.prototype = _.assignIn({}, homeBlog.prototype, {
    _init: function() {
      if(this.blog_slide == '1') {
        this.articleContent.length && this.articleContent.owlCarousel(this.options);
      }
    },
    onUnload: function(evt) {
	  this.$container.off(this.homeBlogNamspace);
    }
  });
  return homeBlog;
})();

theme.homeNewsletter = (function() {
  function homeNewsletter(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.homeNewsletterId = $("#shopify-section-"+sectionId) ;
    this.homeNewsletter = $("#home-newsletter-"+sectionId);
    this.homeNewsletterNamspace = "#home-newsletter-"+sectionId;
    this._init();
  }

  homeNewsletter.prototype = _.assignIn({}, homeNewsletter.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.homeNewsletterNamespace);
    }
  });
  return homeNewsletter;
})();

theme.homeProductTab = (function() {
  function homeProductTab(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.homeProductTabId = $("#shopify-section-"+sectionId) ;
    this.homeProductTab = $("#home-ptab-"+sectionId);
    this.homeProductTabNamspace = "#home-ptab-"+sectionId;
    this.countDown = $('.product_item_countdown_' + sectionId);
    this.slide_enabled =   this.homeProductTab.data('slide_enabled');
    var slide_dots = (this.homeProductTab.data('slide_dots') == '1') ? true : false;
    this.homeProductTabSlide  = $('.home-product-tab-slide-'+ sectionId);
    var item_per_page = this.homeProductTab.data('item_per_page');
    this.slideOptions = {
      mouseDrag: true,
      items: item_per_page,
      itemsDesktop: [1199, item_per_page],
      itemsDesktopSmall: [991, 3],
      itemsTablet: [768, 3],
      itemsTabletSmall: [767, 2],
      itemsMobile: [479, 1],
      pagination: slide_dots,
      navigation: false
    };
    this._init();
  }

  homeProductTab.prototype = _.assignIn({}, homeProductTab.prototype, {
    _init: function() {
      this._initCountdown();
      this._initSlide();
    },
    _initSlide: function() {
      var slideOptions =  this.slideOptions;
      console.log(this.homeProductTabSlide.length);
    	this.slide_enabled == '1' && this.homeProductTabSlide.length > 0 && this.homeProductTabSlide.each(function(){
        	$(this).owlCarousel(slideOptions);
        })
    },
    _initCountdown() {
      if(this.countDown.length > 0) {
        this.countDown.each(function() {
          var year = parseInt( $(this).data("offer_date_year"));
          var month = parseInt( $(this).data("offer_date_month"));
          var day = parseInt( $(this).data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
           $(this).countdown({
              until: offer_date,
              compact: true
            });
          }
          else{
           	$(this).closest('.product_countdown').hide();
          }
        
        });
      }
    },
    onUnload: function(evt) {
	  this.$container.off(this.homeProductTabNamespace);
    }
  });
  return homeProductTab;
})();

theme.productTemplate = (function() {
  function productTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.productTemplateId = $("#shopify-section-"+sectionId) ;
    this.productTemplate = $("#product-main-"+sectionId);
    this.productTemplateNamespace = "#product-main-"+sectionId;
    this.image_slide =  $("#gallery_main");
    this.countDown = $('.product_item_countdown_' + sectionId);
    this.countDownRelated = $('.product_related_item_countdown_' + sectionId);
    this.main_image_display =  this.productTemplate.data('main_image_display');
    this._init();
  }

  productTemplate.prototype = _.assignIn({}, productTemplate.prototype, {
    _init: function() {
      this._initCountdown();
      this._initImageSlide();
      this._initRelatedProduct();
      this._initSidebar();
      this._alwaysRefreshZoom();
      this._handleImageThumbs();
    },
    _initImageSlide: function() {
    	var options = {
          mouseDrag: true,
          items: 3,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [991, 3],
          itemsTablet: [768, 3],
          itemsTabletSmall: [767, 3],
          itemsMobile: [479, 3],
          pagination: false,
          navigation: true,
          navigationText: ['<span class="image_arrow"><i class="zmdi zmdi-long-arrow-left"></i></span>', '<span class="image_arrow"><i class="zmdi zmdi-long-arrow-right"></i></span>']
        };
      this.image_slide.length > 0 && this.image_slide.owlCarousel(options);
    },
    _initCountdown() {
      if(this.countDown.length > 0) {
        this.countDown.each(function() {
          var year = parseInt( $(this).data("offer_date_year"));
          var month = parseInt( $(this).data("offer_date_month"));
          var day = parseInt( $(this).data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
           $(this).countdown({
              until: offer_date,
              compact: true
            });
          }
          else{
           	$(this).closest('.product_countdown').hide();
          }
        
        });
      }
    },
    _initRelatedProduct:  function() {
      	  var related_products_style =  $("#product-related").data('related_products_style');
          var related_products_scroll =  $("#product-related").data('related_products_scroll');
      	  var related_products_item =  $("#product-related").data('related_products_item');
    	 $("#product-related").length && "carousel" == related_products_style && $("#product-related").owlCarousel({
            navigation: false,
            pagination: true,
            mouseDrag: true,
            items: related_products_item,
            itemsDesktop: [1199, related_products_item],
            itemsDesktopSmall: [991, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1],
            scrollPerPage: related_products_scroll
        });
      	if(this.countDownRelated.length > 0) {
          this.countDownRelated.each(function() {
            var year = parseInt( $(this).data("offer_date_year"));
            var month = parseInt( $(this).data("offer_date_month"));
            var day = parseInt( $(this).data("offer_date_day"));
            var current_date = new Date();
            var offer_date = new Date(year, day - 1, month);
            if(current_date < offer_date){
             $(this).countdown({
                until: offer_date,
                compact: true
              });
            }
            else{
              $(this).countDownRelated.hide();
            }

          });
        }
      	
    },
    _alwaysRefreshZoom: function() {
        if (0 == roar.touch && ("zoom" == this.main_image_display || "both" == this.main_image_display) && $(".elevatezoom").length) {
            var e = $(".elevatezoom .img-zoom");
            e.elevateZoom({
                gallery: "gallery_main",
                galleryActiveClass: "active",
                zoomType: "window",
                cursor: "pointer",
                zoomWindowFadeIn: 300,
                zoomWindowFadeOut: 300,
                scrollZoom: !1,
                easing: !0,
                loadingIcon: window.loader_gif
            }), "both" == this.main_image_display && $(".elevatezoom .img-zoom").bind("click", function(e) {
                var a = $(".elevatezoom .img-zoom").data("elevateZoom");
                return $.fancybox(a.getGalleryList(), {
                    closeBtn: !1,
                    helpers: {
                        buttons: {}
                    }
                }), !1
            })
        }
    },
    _handleImageThumbs: function() {
        $("#gallery_main").length && (roar.touch ? $("#product-image .main-image").on("click", function() {
            var e = [],
                a = 0,
                o = $("#product-image .image-thumb");
            return o.each(function(o, t) {
                e.push({
                    href: t.href,
                    title: t.title
                }), $(this).hasClass("active") && (a = o)
            }), $.fancybox(e, {
                closeBtn: !1,
                index: a,
                openEffect: "none",
                closeEffect: "none",
                nextEffect: "none",
                prevEffect: "none",
                helpers: {
                    buttons: {}
                }
            }), !1
        }) : "lightbox" == this.main_image_display && $("#product-image .fancybox").on(roar.clickEv, function() {
            var e = [],
                a = 0,
                o = $("#product-image .image-thumb");
            return o.each(function(o, t) {
                e.push({
                    href: t.href,
                    title: t.title
                }), $(this).hasClass("active") && (a = o)
            }), $.fancybox(e, {
                closeBtn: !1,
                index: a,
                helpers: {
                    buttons: {}
                }
            }), !1
        }), $("#product-image").on("click", ".image-thumb", function() {
            var e = $(this);
            if (!e.hasClass("active")) {
                var a = e.parents(".product-image"),
                    o = e.attr("data-image-zoom"),
                    t = e.attr("data-image");
                a.find(".image-thumb").removeClass("active"), e.addClass("active"), a.find(".main-image").find("img").attr("data-zoom-image", o), a.find(".main-image").find("img").attr("src", t).load(function() {})
            }
            return !1
        }))
    },
    _initSidebar:  function(){
      $('.product-collection-slide').length > 0 && $('.product-collection-slide').each(function() {
      	$(this).owlCarousel({
            navigation: false,
            pagination: false,
            mouseDrag: true,
          	autoPlay:true,
            slideSpeed:2000,
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [991, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1],
            scrollPerPage: true
        });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.productTemplateNamespace);
    }
  });
  return productTemplate;
})();
theme.collectionTemplate = (function() {
  function collectionTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.collectionTemplateId = $("#shopify-section-"+sectionId) ;
    this.collectionTemplate = $("#collection-main-"+sectionId);
    this.collectionTemplateNamespace = "#collection-main-"+sectionId;
    this.countDown = $('.product_item_countdown_' + sectionId);
    this.val_default = this.collectionTemplate.data("val_default");
    this.collection_infinite_scoll =  this.collectionTemplate.data("collection_infinite_scoll");
    this.collection_infinite_scoll_auto =  this.collectionTemplate.data("collection_infinite_scoll_auto");
    this.pInfScrLoading = false;
    this.pInfScrMore = true;
    this.flagScroll = true;
    this._init();
  }

  collectionTemplate.prototype = _.assignIn({}, collectionTemplate.prototype, {
    _init: function() {
      this._initCountdown();
      this._initSidebar();
      this._handleGridList();
      this._handleSortby();
      this._handleFilter();
      this._initCollectionControl();
    },
    _initCollectionControl: function() {
      var thisCT =  this;
      if(this.collection_infinite_scoll == "1") {
        if(this.collection_infinite_scoll_auto == "1") {
          $(window).scroll(function(){
            var $elem = $('.load_more');
            if($elem.length > 0){
              var $window = $(window);

              var docViewTop = $window.scrollTop();
              var docViewBottom = docViewTop + $window.height();

              var elemTop = $elem.offset().top;
              var elemBottom = elemTop + $elem.height();

              if(( elemBottom <= docViewBottom) && (elemTop >= docViewTop) && thisCT.flagScroll)
              {
                thisCT.flagScroll = false;
                $elem.find('a').trigger('click');
              }
            }
          });
        }
        jQuery('.load_more a').click(function(event){
          thisCT._pInfScrExecute();
          event.stopPropagation();
          return false;
        });
      }
    
    },
    _pInfScrExecute: function() {
      var thisCT =  this;
      var pInfScrNode = $('.load_more').last();	
      var pInfScrURL = $('.load_more a').last().attr("href");
      if(pInfScrNode.length > 0 && thisCT.pInfScrMore) {
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            jQuery('.load_more').addClass('invisible');
            jQuery('.loading_img').fadeIn();
          },
          success: function(data) {
            var filteredData = $(data).find(".product-item");
            jQuery("#sandBox").append(filteredData);
            jQuery('.loading_img').fadeOut();

            if(jQuery(data).find(".load_more a").length){
              jQuery('.load_more a').last().attr("href", jQuery(data).find(".load_more a").last().attr("href"));
              jQuery('.load_more').removeClass('invisible');
              thisCT.flagScroll = true;
              // update offset page
              var current_page = parseInt(jQuery(data).find(".load_more a").last().data('page'));
              if(current_page > 0) {
                var page_size = parseInt($('.page-num-offset').data("page_size"));
                var total_display = parseInt($('.page-num-offset').data('total_result'));
				var total_displayed = current_page*page_size;
                if(total_display > total_displayed) {
                	$('.result-offset').html(total_displayed).css('padding-right', "5px");
                  	
                }
              }else{
              	$('.page-num-offset').html($('.page-num-offset').data('total_result'));
              }
            }else{
              thisCT.pInfScrMore = false;
              jQuery('.load_more').remove();
              $('.page-num-offset').html($('.page-num-offset').data('total_result'));
            }
            if($('.shopify-product-reviews-badge').length > 0){
             SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges(); 
            }
            $('[data-toggle="tooltip"]').tooltip();
            thisCT._initCountdown();
          },
          dataType: "html"
        });
      }
    },
    _initCountdown() {
      if(this.countDown.length > 0) {
        this.countDown.each(function() {
          var year = parseInt( $(this).data("offer_date_year"));
          var month = parseInt( $(this).data("offer_date_month"));
          var day = parseInt( $(this).data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
           $(this).countdown({
              until: offer_date,
              compact: true
            });
          }
          else{
           	$(this).closest('.product_countdown').hide();
          }
        
        });
      }
    },
    _handleFilter: function() {
        var e, a, o = $(".advanced-filter");
        o.each(function() {
            var e = $(this);
            e.data("group"), e.hasClass("active-filter")
        }), o.on("click", function(o) {
            var t = $(this),
                i = t.data("group"),
                s = t.find("a").attr("href");
            t.hasClass("active-filter") || (e = $('.active-filter[data-group="' + i + '"]'), e && e.data("group") === i && (o.preventDefault(), a = e.data("handle") + "+", s = s.replace(a, ""), window.location = s))
        })
    },
    _handleSortby: function() {
        "undefined" != typeof this.val_default && (jQuery(".sortBy li.sort-by").removeClass("active"), jQuery(".sortBy li." + this.val_default).addClass("active"), jQuery(".sortBy li.sort-by").click(function() {
            if (!$(this).hasClass("active")) {
                var e = jQuery(this).attr("data-sort");
                Shopify.queryParams.sort_by = e, location.search = jQuery.param(Shopify.queryParams)
            }
        }))
    },
    _handleGridList: function() {
        $(".grid_list span").click(function() {
            $(this).hasClass("active") || ($(".grid_list span").removeClass("active"), $(this).addClass("active"), $(this).hasClass("grid") ? ($("#sandBox").removeClass("list"), $("#sandBox").addClass("grid")) : ($("#sandBox").removeClass("grid"), $("#sandBox").addClass("list")))
        })
    },
    _initSidebar:  function(){
      $('.product-collection-slide').length > 0 && $('.product-collection-slide').each(function() {
      	$(this).owlCarousel({
            navigation: false,
            pagination: false,
            mouseDrag: true,
          	autoPlay:true,
            slideSpeed:2000,
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [991, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1],
            scrollPerPage: true
        });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.collectionTemplateNamespace);
    }
  });
  return collectionTemplate;
})();

theme.collectionsTemplate = (function() {
  function collectionsTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.collectionsTemplateId = $("#shopify-section-"+sectionId) ;
    this.collectionsTemplate = $("#collections-main-"+sectionId);
    this.collectionsTemplateNamespace = "#collections-main-"+sectionId;
    this._init();
  }

  collectionsTemplate.prototype = _.assignIn({}, collectionsTemplate.prototype, {
    _init: function() {
      this._initSidebar();
      //this._initContent();
    },
    _initContent: function() {
      $('.collection-item .img-wrap img').one("load", function(_e) {
        //do some f*cking thing
        var m_height = 250;
        $("#mainCollections.collections-0").length > 0 
        && $("#mainCollections.collections-0").find('.collection-item').length> 0
        && $("#mainCollections.collections-0").find('.collection-item').each(function(){
          if($(this).height() < m_height) {
            m_height = $(this).height();
          }
        });
        $("#mainCollections.collections-0").find('.collection-item').css('height', m_height);
      }).each(function() {
        if(this.complete) $(this).load();
      });

      $( window ).on('resize', function() {
        var m_height = 250;
        $("#mainCollections.collections-0").length > 0 
        && $("#mainCollections.collections-0").find('.collection-item').length> 0
        && $("#mainCollections.collections-0").find('.collection-item').each(function(){
          if($(this).height() < m_height) {
            m_height = $(this).height();
          }
        });
        $("#mainCollections.collections-0").find('.collection-item').css('height', m_height);
      });
    },
    _initSidebar:  function(){
      $('.product-collection-slide').length > 0 && $('.product-collection-slide').each(function() {
      	$(this).owlCarousel({
            navigation: false,
            pagination: false,
            mouseDrag: true,
          	autoPlay:true,
            slideSpeed:2000,
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [991, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1],
            scrollPerPage: true
        });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.collectionsTemplateNamespace);
    }
  });
  return collectionsTemplate;
})();
theme.blogTemplate = (function() {
  function blogTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.blogTemplateId = $("#shopify-section-"+sectionId) ;
    this.blogTemplate = $("#blog-main-"+sectionId);
    this.blogTemplateNamespace = "#blog-main-"+sectionId;
    this._init();
  }

  blogTemplate.prototype = _.assignIn({}, blogTemplate.prototype, {
    _init: function() {
      this._initSidebar();
    },
    _initSidebar:  function(){
      $('.product-collection-slide').length > 0 && $('.product-collection-slide').each(function() {
      	$(this).owlCarousel({
            navigation: false,
            pagination: false,
            mouseDrag: true,
          	autoPlay:true,
            slideSpeed:2000,
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [991, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1],
            scrollPerPage: true
        });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.blogTemplateNamespace);
    }
  });
  return blogTemplate;
})();
theme.articleTemplate = (function() {
  function articleTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.articleTemplateId = $("#shopify-section-"+sectionId) ;
    this.articleTemplate = $("#article-main-"+sectionId);
    this.articleTemplateNamespace = "#article-main-"+sectionId;
    this._init();
  }

  articleTemplate.prototype = _.assignIn({}, articleTemplate.prototype, {
    _init: function() {
      this._initSidebar();
    },
    _initSidebar:  function(){
      $('.product-collection-slide').length > 0 && $('.product-collection-slide').each(function() {
      	$(this).owlCarousel({
            navigation: false,
            pagination: false,
            mouseDrag: true,
          	autoPlay:true,
            slideSpeed:2000,
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [991, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1],
            scrollPerPage: true
        });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.articleTemplateNamespace);
    }
  });
  return articleTemplate;
})();

theme.searchSection = (function() {
  function searchSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.searchTemplateId = $("#shopify-section-"+sectionId) ;
    this.searchTemplate = $("#search-main-"+sectionId);
    this.searchTemplateNamespace = "#search-main-"+sectionId;
    this._init();
  }

  searchSection.prototype = _.assignIn({}, searchSection.prototype, {
    _init: function() {
      this._initSidebar();
    },
    _initSidebar:  function(){
      $('.product-collection-slide').length > 0 && $('.product-collection-slide').each(function() {
      	$(this).owlCarousel({
            navigation: false,
            pagination: false,
            mouseDrag: true,
          	autoPlay:true,
            slideSpeed:2000,
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [991, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1],
            scrollPerPage: true
        });
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.searchTemplateNamespace);
    }
  });
  return searchSection;
})();
theme.notfoundTemplate = (function() {
  function notfoundTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.notfoundTemplateId = $("#shopify-section-"+sectionId) ;
    this.notfoundTemplate = $("#notfound-main-"+sectionId);
    this.notfoundTemplateNamespace = "#notfound-main-"+sectionId;
    this._init();
  }

  notfoundTemplate.prototype = _.assignIn({}, notfoundTemplate.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.notfoundTemplateNamespace);
    }
  });
  return notfoundTemplate;
})();

theme.contactTemplate = (function() {
  function contactTemplate(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.contactTemplateId = $("#shopify-section-"+sectionId) ;
    this.contactTemplate = $("#contact-main-"+sectionId);
    this.contactTemplateNamespace = "#contact-main-"+sectionId;
    this._init();
  }

  contactTemplate.prototype = _.assignIn({}, contactTemplate.prototype, {
    _init: function() {
      this._handleMap();
    },
    _handleMap: function(){
      var  contact_zoom = this.contactTemplate.data('contact_zoom');
      var  contact_scroll = this.contactTemplate.data('contact_scroll');
      var  contact_type = this.contactTemplate.data('contact_type');
      var  contact_address = this.contactTemplate.data('contact_address');
      var  contact_icon = this.contactTemplate.data('contact_icon'); 
      $("#contact_map").length && jQuery().gMap && $("#contact_map").gMap({
        zoom: contact_zoom,
        scrollwheel: contact_scroll,
        maptype: contact_type,
        markers: [{
          address: contact_address,
          html: "_address",
          icon: {
            image: contact_icon,
            iconsize: [188, 68],
            iconanchor: [0, 68]
          }
        }]
      });
    },
    onUnload: function(evt) {
	  this.$container.off(this.contactTemplateNamespace);
    }
  });
  return contactTemplate;
})();

theme.aboutUsIntroSection = (function() {
  function aboutUsIntroSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsIntroId = $("#shopify-section-"+sectionId) ;
    this.aboutUsIntro = $("#about-us-intro-"+sectionId);
    this.aboutUsIntroNamespace = "#about-us-intro-"+sectionId;
    this._init();
  }

  aboutUsIntroSection.prototype = _.assignIn({}, aboutUsIntroSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsIntroNamespace);
    }
  });
  return aboutUsIntroSection;
})();

theme.aboutUsStepsSection = (function() {
  function aboutUsStepsSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsStepsId = $("#shopify-section-"+sectionId) ;
    this.aboutUsSteps = $("#about-us-steps-"+sectionId);
    this.aboutUsStepsNamespace = "#about-us-steps-"+sectionId;
    this._init();
  }

  aboutUsStepsSection.prototype = _.assignIn({}, aboutUsStepsSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsStepsNamespace);
    }
  });
  return aboutUsStepsSection;
})();

theme.aboutUsServicesSection = (function() {
  function aboutUsServicesSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsServicesId = $("#shopify-section-"+sectionId) ;
    this.aboutUsServices = $("#about-us-services-"+sectionId);
    this.aboutUsServicesNamespace = "#about-us-services-"+sectionId;
    this._init();
  }

  aboutUsServicesSection.prototype = _.assignIn({}, aboutUsServicesSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsServicesNamespace);
    }
  });
  return aboutUsServicesSection;
})();

theme.aboutUsPartnersSection = (function() {
  function aboutUsPartnersSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsPartnersId = $("#shopify-section-"+sectionId) ;
    this.aboutUsPartners = $("#about-us-partners-"+sectionId);
    this.aboutUsPartnersSlide = $("#aboutPartners-"+sectionId);
    this.aboutUsPartnersNamespace = "#about-us-partners-"+sectionId;
    var options = this.options = {
      autoPlay:true,
      slideSpeed:2000,
      navigation: false,
      pagination: false,
      mouseDrag: true,
      lazyLoad: !0,
      scrollPerPage: !0,
      items: 5,
      itemsDesktop: [1199, 5],
      itemsDesktopSmall: [991, 4],
      itemsTablet: [768, 3],
      itemsTabletSmall: [767, 3],
      itemsMobile: [479, 1]
    };
    this._init();
  }

  aboutUsPartnersSection.prototype = _.assignIn({}, aboutUsPartnersSection.prototype, {
    _init: function() {
      this._initSlide();
    },
    _initSlide: function(){
    	this.aboutUsPartnersSlide.length && this.aboutUsPartnersSlide.owlCarousel(this.options);
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsPartnersNamespace);
    }
  });
  return aboutUsPartnersSection;
})();


theme.aboutUsFarmersSection = (function() {
  function aboutUsFarmersSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsFarmersId = $("#shopify-section-"+sectionId) ;
    this.aboutUsFarmers = $("#about-us-farmers-"+sectionId);
    this.aboutUsFarmersSlide = $("#aboutus-ourfarmers-"+sectionId);
    this.aboutUsFarmersNamespace = "#about-us-farmers-"+sectionId;
    var options = this.options = {
      autoPlay:true,
      slideSpeed:2000,
      navigation: false,
      pagination: false,
      mouseDrag: true,
      lazyLoad: !0,
      scrollPerPage: !0,
      items: 4,
      itemsDesktop: [1199, 4],
      itemsDesktopSmall: [991, 3],
      itemsTablet: [768, 2],
      itemsTabletSmall: [767, 2],
      itemsMobile: [479, 1]
    };
    this._init();
  }

  aboutUsFarmersSection.prototype = _.assignIn({}, aboutUsFarmersSection.prototype, {
    _init: function() {
      this._initSlide();
    },
    _initSlide: function(){
    	this.aboutUsFarmersSlide.length && this.aboutUsFarmersSlide.owlCarousel(this.options);
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsFarmersNamespace);
    }
  });
  return aboutUsFarmersSection;
})();

theme.aboutUsStorySection = (function() {
  function aboutUsStorySection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsStoryId = $("#shopify-section-"+sectionId) ;
    this.aboutUsStory = $("#about-us-story-"+sectionId);
    this.aboutUsStoryNamespace = "#about-us-story-"+sectionId;
    this._init();
  }

  aboutUsStorySection.prototype = _.assignIn({}, aboutUsStorySection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsStoryNamespace);
    }
  });
  return aboutUsStorySection;
})();

theme.aboutUsClientsSection = (function() {
  function aboutUsClientsSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.aboutUsClientsId = $("#shopify-section-"+sectionId) ;
    this.aboutUsClients = $("#about-us-clients-"+sectionId);
    this.aboutUsClientsNamespace = "#about-us-clients-"+sectionId;
    this._init();
  }

  aboutUsClientsSection.prototype = _.assignIn({}, aboutUsClientsSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.aboutUsClientsNamespace);
    }
  });
  return aboutUsClientsSection;
})();


theme.shopCategorySection = (function() {
  function shopCategorySection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.shopCategoryId = $("#shopify-section-"+sectionId) ;
    this.shopCategory = $("#shop-category-"+sectionId);
    this.shopCategorySlide = $("#shop-category-content-"+sectionId);
    this.shopCategoryNamespace = "#shop-category-"+sectionId;
    var options = this.options = {
      autoPlay:true,
      slideSpeed:2000,
      navigation: false,
      pagination: false,
      mouseDrag: true,
      lazyLoad: !0,
      scrollPerPage: !0,
      items: 5,
      itemsDesktop: [1199, 4],
      itemsDesktopSmall: [991, 3],
      itemsTablet: [768, 2],
      itemsTabletSmall: [767, 2],
      itemsMobile: [479, 1]
    };
    this._init();
  }

  shopCategorySection.prototype = _.assignIn({}, shopCategorySection.prototype, {
    _init: function() {
      this._initSlide();
    },
    _initSlide: function(){
    	this.shopCategorySlide.length && this.shopCategorySlide.owlCarousel(this.options);
    },
    onUnload: function(evt) {
	  this.$container.off(this.shopCategoryNamespace);
    }
  });
  return shopCategorySection;
})();

theme.WhyChooseSection = (function() {
  function WhyChooseSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.whyChooseId = $("#shopify-section-"+sectionId) ;
    this.whyChoose = $("#why-choose-"+sectionId);
    this.whyChooseNamespace = "#why-choose-"+sectionId;
    this._init();
  }

  WhyChooseSection.prototype = _.assignIn({}, WhyChooseSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.whyChooseNamespace);
    }
  });
  return WhyChooseSection;
})();

theme.cartSection = (function() {
  function cartSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.cartTemplateId = $("#shopify-section-"+sectionId) ;
    this.cartTemplate = $("#cart-main-"+sectionId);
    this.cartSlide = $("#cart-product-"+sectionId);
    this.cartTemplateNamespace = "#cart-main-"+sectionId;
    this.clearCartBtn = $("#clear-cart-"+sectionId);
    this.countDown = $('.product_item_countdown_' + sectionId);
    this._init();
  }

  cartSection.prototype = _.assignIn({}, cartSection.prototype, {
    _init: function() {
      this._initRelatedProduct();
      this._initQuatity();
      this._initClearCart();
    },
    _initQuatity: function() {
    	$('#q_up').click(function(){
          var p_id = $(this).data("product_id");
          var q_value =  parseInt($('.quantity-cart-'+p_id).val()) + 1 ;
          $('.quantity-cart-'+p_id).val(q_value);
        });
      $('#q_down').click(function(){
        var p_id = $(this).data("product_id");
        var q_value =  parseInt($('.quantity-cart-'+p_id).val());
        if(q_value > 1) {
          $('.quantity-cart-'+p_id).val(q_value -1);
        }
      });
    },
    _initClearCart: function() {
      this.clearCartBtn.length > 0 && this.clearCartBtn.click(function(){
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
            window.location.reload();
          },
          dataType: 'json'
        });
      });
    },
    _initRelatedProduct:  function() {
      var cart_product_style =  this.cartSlide.data('cart_product_style');
      var cart_product_scroll = this.cartSlide.data('cart_product_scroll');
      
      this.cartSlide.length && "carousel" == cart_product_style && this.cartSlide.owlCarousel({
        navigation: false,
        pagination: true,
        mouseDrag: true,
        items: 4,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [991, 3],
        itemsTablet: [768, 2],
        itemsMobile: [479, 1],
        scrollPerPage: cart_product_scroll
      });
      if(this.countDown.length > 0) {
        this.countDown.each(function() {
          var year = parseInt( $(this).data("offer_date_year"));
          var month = parseInt( $(this).data("offer_date_month"));
          var day = parseInt( $(this).data("offer_date_day"));
          var current_date = new Date();
          var offer_date = new Date(year, day - 1, month);
          if(current_date < offer_date){
            $(this).countdown({
              until: offer_date,
              compact: true
            });
          }
          else{
            $(this).countDown.hide();
          }

        });
      }

    },
    onUnload: function(evt) {
	  this.$container.off(this.cartTemplateNamespace);
    }
  });
  return cartSection;
})();

theme.footerSection = (function() {
  function footerSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.footerId = $("#shopify-section-"+sectionId) ;
    this.footer = $("#footer");
    this.footerNamespace = "#footer";
    this._init();
  }

  footerSection.prototype = _.assignIn({}, footerSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.footerNamespace);
    }
  });
  return footerSection;
})();

theme.textImageSection = (function() {
  function textImageSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.textImageId = $("#shopify-section-"+sectionId) ;
    this.textImage = $("#home-textimage-"+sectionId);
    this.textImageNamespace = "#home-textimage-"+sectionId;
    this._init();
  }

  textImageSection.prototype = _.assignIn({}, textImageSection.prototype, {
    _init: function() {
    },
    onUnload: function(evt) {
	  this.$container.off(this.textImageNamespace);
    }
  });
  return textImageSection;
})();


theme.topBarSection = (function() {
  function topBarSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.topBarId = $("#shopify-section-"+sectionId) ;
    this.topBar = $("#top-header");
    this.topBarNamespace = "#top-header";
    this._init();
  }

  topBarSection.prototype = _.assignIn({}, topBarSection.prototype, {
    _init: function() {
      $('#shopify-section-header-top-bar').prev().height() > 0 && $('#shopify-section-header-top-bar').prev().css("z-index", 99)
    },
    onUnload: function(evt) {
	  this.$container.off(this.topBarNamespace);
    }
  });
  return topBarSection;
})();

theme.headerSection = (function() {
  function headerSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.headerId = $("#shopify-section-"+sectionId) ;
    this.header = $("#header");
    this.headerNamespace = "#header";
    this._search_ajax = (this.header.data('_search_ajax') == "1" ) ? true : false;
    this._init();
  }

  headerSection.prototype = _.assignIn({}, headerSection.prototype, {
    _init: function() {
      this._initHeaderSearchIcon();
      this._initHeaderSticky();
      this._initMobileMenu();
      this._initActiveMenu();
      this._initAjaxSearch();
    },
    _initHeaderSearchIcon: function() {
      $('#header-search-icon').length > 0 && $("#header-search-icon").unbind('click') && $("#header-search-icon").on('click', function(e){
        e.preventDefault();
        jQuery(".close_menu").trigger("click");
        jQuery(".header-search-wapper").toggleClass("openSearch");
      });
      $("#close_search_top").length > 0 && $("#close_search_top").unbind('click') &&  $("#close_search_top").on('click', function(e) {
      	e.preventDefault();
        jQuery(".close_menu").trigger("click");
        jQuery(".header-search-wapper").removeClass("openSearch");
      });
    },
    _initActiveMenu:function(){
		var urlPath = location.pathname;
		var urlFull = location.href;
		var check = jQuery('ul.megamenu > li > a[href="'+urlFull+'"]').html();
		if(typeof check != "undefined"){
			jQuery('ul.megamenu > li > a[href="'+urlFull+'"]').closest("li").addClass("active");
		}else{
			jQuery('a[href="'+urlPath+'"]').closest(".widget-heading").addClass("active");
			jQuery('a[href="'+urlFull+'"]').closest(".widget-heading").addClass("active");
			jQuery('a[href="'+urlPath+'"]').closest("li").addClass("active");
			jQuery('a[href="'+urlFull+'"]').closest("li").addClass("active");
			jQuery('a[href="'+urlFull+'"]').closest("li.parent.dropdown").addClass("active");
			jQuery('a[href="'+urlFull+'"]').closest("li").parents("li").addClass("active");
            jQuery('a[href="'+urlFull+'"]').closest("li.parent.dropdown-submenu").addClass("active");
            jQuery('a[href="'+urlPath+'"]').closest("li.parent.dropdown-submenu").addClass("active");
            jQuery('a[href="'+urlFull+'"]').closest("li.dor-menu-item-linklist.parent.dropdown").addClass("active");
            jQuery('a[href="'+urlPath+'"]').closest("li.dor-menu-item-linklist.parent.dropdown").addClass("active");
            jQuery('a[href="'+urlFull+'"]').closest("li.dor-menu-item-column.parent.dropdown").addClass("active");
            jQuery('a[href="'+urlPath+'"]').closest("li.dor-menu-item-column.parent.dropdown").addClass("active");
            jQuery('a[href="'+urlPath+'"]').closest('.widget-subcategories').find(".widget-heading.title_block").addClass("active");
            jQuery('a[href="'+urlPath+'"]').closest('.widget-subcategories').find(".widget-heading.title_block").addClass("active");
		}
	},
    _initHeaderSticky:  function() {
      if($('#header').data('header_sticky') == '1' ){
        
          var header_height = parseInt($('#shopify-section-header').height());
        var content_padding = parseInt($('#header').data('content_padding'));
        $(window).bind('scroll', function() {
          var navHeight = $('#shopify-section-header-top-bar').height() + $('#shopify-section-header').height();
          if(jQuery("#shopify-section-header-slider").height() > 0) {
            var navHeight = $('#shopify-section-header-slider').height() + $('#shopify-section-header-top-bar').height()  + $('#shopify-section-header').height();
          }
          if ($(window).scrollTop() > navHeight) {
            $('body').addClass('fixed');
            $('#header').addClass('fixed fixed-tran');
            var checkLogoFix = jQuery(".logoFixed").html();
            if(jQuery.trim(checkLogoFix).length == 0){
              var logo = jQuery(".logo.img-responsive").attr("src");
              var linkHomePage = jQuery("#header_logo > a").attr("href");
            }
            $('#shopify-section-header-top-bar .header-search-wapper').detach().insertBefore('.header-top');
            if($('#header').hasClass('header-style-2')) {
              jQuery("#header_logo").detach().insertAfter('.menu-header-inner');
            }
            $("#module-content").css("margin-top", header_height + content_padding + 'px');
          }
          else {
            $('body').removeClass('fixed');
            $('#header').removeClass('fixed');
            $('#header').removeClass('fixed-tran');
            jQuery(".logoFixed").remove();
            $('#header .menu-group-show .header-search-wapper').detach().insertBefore('#top-header');
            if($('#header').hasClass('header-style-2')) {
              jQuery(".dorHeader_menu > .container #header_logo").detach().insertBefore('.dorHeader_menu');
            }
            
            $("#module-content").css("margin-top", '-'+ content_padding + 'px');
          }
        });
      }
    },
    _initMobileMenu: function() {
        jQuery(".open_menu").click(function(){
          if(jQuery( "#shopify-section-header-options-canvas" )) {
            jQuery( ".header-options-canvas-icon-off" ) .trigger("click"); 
          }
          jQuery( "#dor-top-menu" ).animate({
            left: 0,
          }, 500);
          jQuery("body").addClass("dor-mobile");
          jQuery(".header-search-wapper").removeClass("openSearch");
        });
        jQuery(".close_menu").click(function(){
          //jQuery(".header-options-canvas-icon-off").trigger('click');
          jQuery( "#dor-top-menu" ).animate({
            left: -250,
          }, 500);
          jQuery("body").removeClass("dor-mobile");
        });
        this._initToggleMenuLine();
	},
    _initToggleMenuLine:function(){
      jQuery(".caretmobile").click(function(){
        var checkStatus = jQuery(this).parent("li").hasClass("dor-menu-open");
        jQuery(this).parent("li").parent("ul").find("li").removeClass("dor-menu-open");
        var checkStatusWidget = jQuery(this).closest(".widget-content").hasClass("dor-menu-open");
        jQuery(this).closest("li.dor-menu-open").find(".widget-content").removeClass("dor-menu-open");
        if(!checkStatus)
          jQuery(this).closest("li").addClass("dor-menu-open");
        else
          jQuery(this).closest("li").removeClass("dor-menu-open");

        if(checkStatusWidget){
          jQuery(this).closest(".widget-content").removeClass("dor-menu-open");
        }else{
          jQuery(this).closest(".widget-content").addClass("dor-menu-open");
        }
      });
    },
    _initAjaxSearch: function() {
        if (this._search_ajax) {
          var a = null;
          $('form#top-search-box').unbind('click');
          $('form#top-search-box').each(function() {
            var b = "product",
                c = $(this).find('select[name="category_id"]'),
                d = $(this).find('input[name="type"]');
            c.length > 0 && d.length > 0 && $(c).bind("change", function() {
              $(d).val($(this).val()), b = $(this).val()
            });
            var e = $(this).find('input[name="q"]');
            $('<ul class="ui-autocomplete ui-front"></ul>').appendTo($(this).find(".autocomplete-results")).hide(), e.attr("autocomplete", "off").bind("keyup change", function() {
              var c = $(this).val(),
                  d = $(this).closest("form"),
                  f = "/search?type=" + b + "&q=*" + c + "*",
                  g = d.find(".ui-autocomplete");
              c.length >= 3 && c != $(this).attr("data-old-term") && (e.addClass("ui-autocomplete-loading"), $(this).attr("data-old-term", c), null != a && a.abort(), a = $.getJSON(f + "&view=json", function(a) {
                e.removeClass("ui-autocomplete-loading"), g.empty(), 0 == a.results_count ? g.hide() : ($.each(a.results, function(a, b) {
                  var c = $("<a></a>").attr("href", b.url);
                  c.append('<span class="thumbnail"><img src="' + b.thumbnail + '" /></span>'), c.append('<span class="title">' + b.title + "</span>"), c.wrap("<li></li>"), g.append(c.parent())
                }), a.results_count > 1 && g.append('<li><span class="title"><a href="' + f + '">' + window.all_results_text + " (" + a.results_count + ")</a></span></li>"), g.fadeIn(200))
              }))
            })
          }), $("body").bind("click", function() {
            $(".ui-autocomplete").hide()
          })
        }
    },
    onUnload: function(evt) {
	  this.$container.off(this.headerNamespace);
    }
  });
  return headerSection;
})();

theme.optionsCanvasSection = (function() {
  function optionsCanvasSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var sectionType = $container.attr('data-section-type');
   	this.optionsCanvasId = $("#shopify-section-"+sectionId) ;
    this.optionsCanvas = $("#options-canvas");
    this.optionsCanvasNamespace = "#options-canvas";
    this._search_ajax = (this.optionsCanvas.data('_search_ajax') == "1" ) ? true : false;
    this._init();
  }

  optionsCanvasSection.prototype = _.assignIn({}, optionsCanvasSection.prototype, {
    _init: function() {
      this._initCanvas();
      this._initAjaxSearch();
    },
    _initCanvas: function() {
      var canvas_width =  -450;
      if($( window ).width() <= 480) {
      	canvas_width =  -300;
      }
      jQuery(".header-options-canvas-icon").click(function(){
        if($('#dor-top-menu').is(":visible")) {
          jQuery(".close_menu").trigger("click");
        }
        jQuery( "#shopify-section-header-options-canvas" ).animate({
          right: 0,
        }, 500, function(){
          jQuery("body").addClass("dor-canvas-on");
          jQuery(".header-search-wapper").removeClass("openSearch");
        });
      });
      jQuery(".header-options-canvas-icon-off").click(function(){
        jQuery( "#shopify-section-header-options-canvas" ).animate({
          right: canvas_width,
        }, 500, function(){
           jQuery("body").removeClass("dor-canvas-on");
        });
      });
      this._initResizeWindow();
	},
    _initResizeWindow: function() {
      $( window ).resize(function() {
      	 var canvas_width =  450;
         var canvas_right = -450;
        if($( window ).width() <= 480) {
      	 canvas_width =  300;
         canvas_right = -300;
        }
        jQuery(".header-options-canvas-icon").unbind('click');
        jQuery(".header-options-canvas-icon").click(function(){
          jQuery(".close_menu").trigger("click");
          jQuery( "#shopify-section-header-options-canvas" ).animate({
            right: 0,
          }, 500, function(){
            jQuery("body").addClass("dor-canvas-on");
          });
        });
        jQuery(".header-options-canvas-icon-off").unbind('click');
        jQuery(".header-options-canvas-icon-off").click(function(){
          jQuery(".close_menu").trigger("click");
          jQuery( "#shopify-section-header-options-canvas" ).animate({
            right: canvas_right,
          }, 500, function(){
            jQuery("body").removeClass("dor-canvas-on");
          });
        });
        
        $('#shopify-section-header-options-canvas').css('right', canvas_right);
        $('#shopify-section-header-options-canvas').css('width', canvas_width);
        
      });
    },
    _initAjaxSearch: function() {
        if (this._search_ajax) {
          var a = null;
          $('form#canvas-search-box').unbind('click');
          $('form#canvas-search-box').each(function() {
            var b = "product",
                c = $(this).find('select[name="category_id"]'),
                d = $(this).find('input[name="type"]');
            c.length > 0 && d.length > 0 && $(c).bind("change", function() {
              $(d).val($(this).val()), b = $(this).val()
            });
            var e = $(this).find('input[name="q"]');
            $('<ul class="ui-autocomplete ui-front"></ul>').appendTo($(this).find(".autocomplete-results")).hide(), e.attr("autocomplete", "off").bind("keyup change", function() {
              var c = $(this).val(),
                  d = $(this).closest("form"),
                  f = "/search?type=" + b + "&q=*" + c + "*",
                  g = d.find(".ui-autocomplete");
              c.length >= 3 && c != $(this).attr("data-old-term") && (e.addClass("ui-autocomplete-loading"), $(this).attr("data-old-term", c), null != a && a.abort(), a = $.getJSON(f + "&view=json", function(a) {
                e.removeClass("ui-autocomplete-loading"), g.empty(), 0 == a.results_count ? g.hide() : ($.each(a.results, function(a, b) {
                  var c = $("<a></a>").attr("href", b.url);
                  c.append('<span class="thumbnail"><img src="' + b.thumbnail + '" /></span>'), c.append('<span class="title">' + b.title + "</span>"), c.wrap("<li></li>"), g.append(c.parent())
                }), a.results_count > 1 && g.append('<li><span class="title"><a href="' + f + '">' + window.all_results_text + " (" + a.results_count + ")</a></span></li>"), g.fadeIn(200))
              }))
            })
          }), $("body").bind("click", function() {
            $(".ui-autocomplete").hide()
          })
        }
    },
    onUnload: function(evt) {
	  this.$container.off(this.optionsCanvasNamespace);
    }
  });
  return optionsCanvasSection;
})();

$(document).ready(function() {  
  var sections = new theme.Sections();
  sections.register('home-slider', theme.Sliders);
  sections.register('home-video', theme.Videos);
  sections.register('home-collections', theme.homeCollectionsSection);
  sections.register('special-collection', theme.specialCollectionSection);
  sections.register('instafeed-section', theme.instafeedSection);
  sections.register('photos-board', theme.photoBoardSection);
  sections.register('white-space', theme.whiteSpaceSection);
  sections.register('special-line', theme.specialLineSection);
  sections.register('home-product', theme.homeProductSection);
  sections.register('text-banner', theme.textBannerSection);
  sections.register('promotion', theme.promotionSection);
  sections.register('banner', theme.bannerSection);
  sections.register('delivery-process', theme.deliverySection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('home-blog', theme.homeBlog);
  sections.register('home-newsletter', theme.homeNewsletter);
  sections.register('home-ptab', theme.homeProductTab);
  sections.register('product-template', theme.productTemplate);
  sections.register('collection-template', theme.collectionTemplate);
  sections.register('collections-template', theme.collectionsTemplate);
  sections.register('collections-template-v2', theme.collectionsTemplate);
  sections.register('blog-template', theme.blogTemplate);
  sections.register('article-template', theme.articleTemplate);  
  sections.register('article-template-v2', theme.articleTemplate);
  sections.register('notfound-template', theme.notfoundTemplate);
  sections.register('contact-template', theme.contactTemplate);
  sections.register('about-us-intro', theme.aboutUsIntroSection);
  sections.register('about-us-steps', theme.aboutUsStepsSection);
  sections.register('about-us-services', theme.aboutUsServicesSection);
  sections.register('about-us-partners', theme.aboutUsPartnersSection);
  sections.register('about-us-farmers', theme.aboutUsFarmersSection);
  sections.register('about-us-story', theme.aboutUsStorySection);
  sections.register('about-us-clients', theme.aboutUsClientsSection);
  sections.register('search-template', theme.searchSection);
  sections.register('cart-template', theme.cartSection);
  sections.register('shop-category', theme.shopCategorySection);
  sections.register('shop-category-v2', theme.shopCategorySection);
  sections.register('why-choose', theme.whyChooseSection);
  sections.register('home-textimage', theme.textImageSection);
  sections.register('footer-section', theme.footerSection);
  sections.register('header-section', theme.headerSection);
  sections.register('header-options-canvas', theme.optionsCanvasSection);
  sections.register('header-top-bar', theme.topBarSection);
});
